import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Card = styled.div`
  border: "0";
  padding: 0px 0px;
  color: black;
  background-color: #d8d8d8;
  height: 6rem;
  width: 100%;
  //box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
`;

const Data1 = styled.div`
  font-size: 2.2rem;
  font-weight: 500;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Data2 = styled.div`
  margin-top: 0.3rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  opacity: 0.65;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 1rem 1rem 1rem 1rem;
`;

function CustomSubCardData(props) {
  return (
    <div>
      <Card>
        <DataContainer>
          <Data1>{props.dataResult}</Data1>
          <Data2>{props.dataName}</Data2>
        </DataContainer>
      </Card>
    </div>
  );
}

CustomSubCardData.propTypes = {
  dataName: PropTypes.string,
  dataResult: PropTypes.string,
};

export default CustomSubCardData;
